import { withStyles } from '@material-ui/core';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import withQuerySync from '@/hocs/withQuerySync';

import queryDuck from '../ducks/query';
import {
  getReconciliationError,
  getReconciliationIds,
  getReconciliationTotalCount,
  getStoreId,
  isLoadingReconciliation,
} from '../selectors';
import ReconciliationArchiveRefunds from './component';
import styles from './styles';

const mapStateToProps = state => {
  const storeId = getStoreId(state);

  return {
    error: getReconciliationError(state),
    reconciliationIds: getReconciliationIds(state),
    isLoading: isLoadingReconciliation(state),
    totalCount: getReconciliationTotalCount(state),
    storeId,
  };
};

export default compose(
  withQuerySync(queryDuck),
  connect(mapStateToProps),
  withStyles(styles),
)(ReconciliationArchiveRefunds);
